import Cookies from 'js-cookie';

jQuery( function ($) {
    /**
     * This function is called when a user clicks on a product link in a list
     */
    /*
    $(document).on('click', '[data-enec-item-link]', function(e){
        e.preventDefault();

        var data = $(this).parents('[data-enec-item-list]').data('enec-item-list');
        var url  = $(this).attr('href');

        // if there is no data continue to product detail page
        if (!data || !data.items) {
            window.location.href = url;
            return;
        }

        var list_item = {
            'item_id': data.items[0].item_id,
            'index': data.items[0].index,
            'item_list_name': data.item_list_name,
            'item_list_id': data.item_list_id
        };

        wpg_shop_save_list_data(list_item);

        window.dataLayer = window.dataLayer || []; 
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {
            window.dataLayer.push({ecommerce: null}); 

            // Measure clicking on a product in a list
            window.dataLayer.push({ 
                'event': 'ecommerce_select_item',
                'ecommerce': { 
                    'item_list_name': data.item_list_name,
                    'item_list_id': data.item_list_id,
                    'items': data.items
                },
                'eventCallback': function() {
                    // continue to product detail page
                    window.location.href = url;
                }
            });
        });
    });
    */

    /**
     * This function is called when a user clicks on a product link in a list
     */
     $(document).on('wpg-shop-save-list-data', function(e, element){

        var data = $(element).parents('[data-enec-item-list]').data('enec-item-list');

        // if there is no data continue to product detail page
        if (!data || !data.items) {
            return;
        }

        var list_item = {
            'item_id': data.items[0].item_id,
            'index': data.items[0].index,
            'item_list_name': data.item_list_name,
            'item_list_id': data.item_list_id
        };

        wpg_shop_save_list_data(list_item);
    });


    /**
     * Save list item data in cookie to use later in purchase event
     */
    function wpg_shop_save_list_data(list_item) {

        var ecom_list_data = Cookies.get('ecListData');
        var add_item = true;

        if (ecom_list_data) {
            ecom_list_data = JSON.parse(ecom_list_data);
        } else {
            ecom_list_data = [];
        }
        
        $.each(ecom_list_data, function(index, item) {
            // check if item is already in list to avoid adding duplicates
            if (item.item_id === list_item.item_id) {
                add_item = false;
            }
        });

        if (add_item) {
            ecom_list_data.push(list_item);
            Cookies.set('ecListData', JSON.stringify(ecom_list_data));
        }
    }


    /**
     * This function is called when a post is added to favorites list/wishlist
     */
    $(document).on("wpgu-favorite-added", function(e, post_id) {

        var quantity = 1;

        if (!post_id) {
            return false;
        }

        $.ajax({
            url      : WPGShopEE.ajaxUrl,
            type     : 'POST',
            dataType : 'json',
            data     : {
                action    : 'wpg_shop_added_to_wishlist',
                product_id : post_id,
                quantity: quantity
            }
        }).done(function(response) {

            if (true !== response.success || !response.data.items) {
                return;
            }

            window.dataLayer = window.dataLayer || []; 
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push({ecommerce: null}); 

                // Measure adding a product to a shopping cart
                window.dataLayer.push({ 
                    'event': 'ecommerce_add_to_wishlist',
                    'ecommerce': { 
                        'items': response.data.items
                    }
                });
            });
        });
    });


    /**
     * This function is called when a product is viewed with an element on the page with data-enec-product-view
     */
    if ($('[data-enec-product-view]').length) {

        var $enec_el = $('[data-enec-product-view]');
        var product_id = $enec_el.data('enec-product-view');

        if (!product_id) {
            return false;
        }

        $.ajax({
            url      : WPGShopEE.ajaxUrl,
            type     : 'POST',
            dataType : 'json',
            data     : {
                action    : 'wpg_shop_view_product',
                product_id : product_id
            }
        }).done(function(response) {

            if (true !== response.success || !response.data.items) {
                return;
            }

            window.dataLayer = window.dataLayer || []; 
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push({ecommerce: null}); 

                // Measure viewing a product
                window.dataLayer.push({ 
                    'event': 'ecommerce_view_item',
                    'ecommerce': { 
                        'items': response.data.items
                    }
                });
            });
        });
    }


    /**
     * This function is called when the a product is added to the cart without an ajax call. 
     * The data is in the product added notice from Woocommerce
     */
    if ($('[data-enec-products-added]').length) {
        var $enec_el = $('[data-enec-products-added]');

        var items = $enec_el.data('enec-products-added');
        var total = parseFloat($enec_el.data('enec-total'));
        
        window.dataLayer = window.dataLayer || []; 
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {
            window.dataLayer.push({ecommerce: null}); 

            // Measure adding a product to a shopping cart
            window.dataLayer.push({ 
                'event': 'ecommerce_add_to_cart', 
                'ecommerce': { 
                    'items': items
                }
            });
        });

        $('[data-enec-products-added]').remove();

        // send view cart event after add to cart event
        wpg_shop_view_cart();

    } else {
        // if there is no add to cart message send add to cart event right away
        wpg_shop_view_cart();
    }

    
    /**
     * This function is called when a user views the cart. 
     * The data is in a div element with data-enec-view-cart
     */
    function wpg_shop_view_cart() {
        if ($('[data-enec-view-cart]').length) {
            var $enec_el = $('[data-enec-view-cart]');

            var items = $enec_el.data('enec-view-cart');
            var total = parseFloat($enec_el.data('enec-total'));
            
            window.dataLayer = window.dataLayer || []; 
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push({ecommerce: null}); 

                // Measure adding a product to a shopping cart
                window.dataLayer.push({ 
                    'event': 'ecommerce_view_cart', 
                    'ecommerce': { 
                        'items': items
                    }
                });
            });
        }
    }


    /**
     * This function is called when a user adds a product to the cart with Ajax
     */
    $('body').on('added_to_cart', function(e, fragments, cart_hash, $this_button) {

        var product_id = $this_button.val();
        var quantity = $this_button.data('quantity');

        if (!quantity) {
            quantity = 1;
        }

        // in case of a product variation get the variation id
        if (!product_id && $('.single-product input[name="variation_id"]').length) {
            product_id = $('.single-product input[name="variation_id"]').val();
        }

        if (!product_id) {
            return false;
        }

        $.ajax({
            url      : WPGShopEE.ajaxUrl,
            type     : 'POST',
            dataType : 'json',
            data     : {
                action    : 'wpg_shop_added_to_cart',
                product_id : product_id,
                quantity: quantity
            }
        }).done(function(response) {

            if (true !== response.success || !response.data.items) {
                return;
            }

            window.dataLayer = window.dataLayer || []; 
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push({ecommerce: null}); 

                // Measure adding a product to a shopping cart
                window.dataLayer.push({ 
                    'event': 'ecommerce_add_to_cart', 
                    'ecommerce': { 
                        'items': response.data.items
                    }
                });
            });
        });
    });


    /**
     * This function is called when the cart is updated or emptied. 
     * The data for this event is added to the item removed from cart notice from Woocommerce
     */
    $('body').on('updated_cart_totals wc_cart_emptied', function() {

        if (!$('[data-enec-products-removed]').length) {
            return false;
        }

        var $enec_el = $('[data-enec-products-removed]');

        var items = $enec_el.data('enec-products-removed');
        var total = parseFloat($enec_el.data('enec-total'));
        
        window.dataLayer = window.dataLayer || []; 
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {
            window.dataLayer.push({ecommerce: null}); 

            // Measure adding a product to a shopping cart
            window.dataLayer.push({ 
                'event': 'ecommerce_remove_from_cart', 
                'ecommerce': { 
                    'items': items
                }
            });
        });

        $('[data-enec-products-removed]').remove();
    });


    /**
     * This function is called when a user has added a bargain product to the cart
     * This function is called from the wpg-shop-public-scripts.js file in the bargain add to cart function
     */
    if (!window.add_to_cart_bargain_gtm_event) {
        window.add_to_cart_bargain_gtm_event = function(data) {

            if (!data.total || !data.items) {
                return false;
            }

            window.dataLayer = window.dataLayer || []; 
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push({ecommerce: null}); 

                // Measure adding a product to a shopping cart
                window.dataLayer.push({ 
                    'event': 'ecommerce_add_to_cart', 
                    'ecommerce': { 
                        'items': data.items
                    }
                });
            });
        };
    };


    /**
     * This function is called when a user has filled the required billing fields on the Woocommerce checkout page
     */
    $(document).on('focusout', '.woocommerce-checkout input.input-text', function(e) {

        if ($('[data-enec]').length) {

            var required_fields_filled = true;

            // check if the required billing fields are filled. 
            $(".woocommerce-billing-fields .validate-required input.input-text" ).each(function(index) {
                // don't check email field because this has a seperate event
                if ($(this).attr('name') === "billing_email") {
                    return; // this is equivalent of 'continue' for jQuery loop
                }
                
                if (!$(this).val()) {
                    required_fields_filled = false;
                }
            });

            var $enec_el = $('[data-enec]');
            // check if the event has already been sent before
            var required_fields_done = $enec_el.data('enec-required-fields-done');

            // only send the data if the fields are filled and it hasn't been done before
            if (required_fields_filled && !required_fields_done) {
                var data = wpg_shop_get_enec_data();

                window.dataLayer = window.dataLayer || []; 
                window.didomiOnReady = window.didomiOnReady || [];
                window.didomiOnReady.push(function (Didomi) {
                    window.dataLayer.push({ecommerce: null}); 

                    window.dataLayer.push({ 
                        'event': 'ecommerce_add_shipping_info', 
                        'ecommerce': { 
                            'coupon': data.coupons, 
                            'items': data.items
                        }
                    });
                });

                // set the data value to true to prevent sending it again
                $enec_el.data('enec-required-fields-done', true);
            }
        }
    });


    /**
     * This function is called when a user has filled the email field on the Woocommerce checkout page
     */
    $(document).on('focusout', '.woocommerce-checkout input#billing_email', function(e) {

        if ($('[data-enec]').length && $(this).val()) {

            var $enec_el = $('[data-enec]');
            // check if the event has already been sent before
            var email_done = $enec_el.data('enec-email-done');

            // only send the data if the fields are filled and it hasn't been done before
            if (!email_done) {
                var data = wpg_shop_get_enec_data();

                window.dataLayer = window.dataLayer || []; 
                window.didomiOnReady = window.didomiOnReady || [];
                window.didomiOnReady.push(function (Didomi) {
                    window.dataLayer.push({ecommerce: null}); 

                    window.dataLayer.push({ 
                        'event': 'ecommerce_add_contact_info', 
                        'ecommerce': { 
                            'coupon': data.coupons, 
                            'items': data.items
                        }
                    }); 
                });

                // set the data value to true to prevent sending it again
                $enec_el.data('enec-email-done', true);
            }
        }
    });


    /**
     * This function is called when a user picks a payment method on the Woocommerce checkout page
     */
     $(document).on('change', '.woocommerce-checkout input[name="payment_method"], .woocommerce-checkout select[name="mollie-payments-for-woocommerce_issuer_mollie_wc_gateway_ideal"]', function(e) {

        if ($('[data-enec]').length && $(this).val()) {

            var $enec_el = $('[data-enec]');
            // check if the event has already been sent before with the same payment method
            var previous_payment = $enec_el.data('enec-payment-done');
            var payment = wpg_shop_get_payment_method();

            if (payment !== previous_payment) {
                var data = wpg_shop_get_enec_data();

                window.dataLayer = window.dataLayer || []; 
                window.didomiOnReady = window.didomiOnReady || [];
                window.didomiOnReady.push(function (Didomi) {
                    window.dataLayer.push({ecommerce: null}); 

                    window.dataLayer.push({ 
                        'event': 'ecommerce_add_payment_info', 
                        'ecommerce': { 
                            'coupon': data.coupons, 
                            'payment_type': payment,
                            'items': data.items
                        }
                    });
                });

                // set the data value to prevent sending it again with the same payment method
                $enec_el.data('enec-payment-done', payment);
            }
        }
    });


    /**
     * This function is called when a user checks the terms checkbox on the Woocommerce checkout page
     */
    $(document).on('change', '.woocommerce-checkout input#terms', function(e) {

        if ($(this).prop("checked") == true && $('[data-enec]').length) {
            
            var $enec_el = $('[data-enec]');
            // check if the event has already been sent before
            var terms_done = $enec_el.data('enec-terms-done');
            var data = wpg_shop_get_enec_data();

            // only send the data if it hasn't been done before
            if (!terms_done) {

                window.dataLayer = window.dataLayer || []; 
                window.didomiOnReady = window.didomiOnReady || [];
                window.didomiOnReady.push(function (Didomi) {
                    window.dataLayer.push({ecommerce: null}); 

                    window.dataLayer.push({ 
                        'event': 'ecommerce_terms_accepted', 
                        'ecommerce': { 
                            'coupon': data.coupons, 
                            'items': data.items
                        }
                    }); 
                });

                // set the data value to true to prevent sending it again
                $enec_el.data('enec-terms-done', true);
            }
        }
    });


    /**
     * This function is called when a user clicks the submit button on the Woocommerce checkout page
     */
    $("form.woocommerce-checkout").on('submit', function(e) {
        e.preventDefault();
        if ($('[data-enec]').length) {

            var payment = wpg_shop_get_payment_method();
            var data = wpg_shop_get_enec_data();

            window.dataLayer = window.dataLayer || []; 
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push({ecommerce: null}); 

                window.dataLayer.push({ 
                    'event': 'ecommerce_checkout_payment', 
                    'ecommerce': { 
                        'coupon': data.coupons, 
                        'payment_type': payment,
                        'items': data.items
                    }
                });
            });
        }
    });


    /**
     * This function is called to retrieve data from an element on the page with data-enec
     */
    function wpg_shop_get_enec_data() {

        if ($('[data-enec]').length) {
            var $enec_el = $('[data-enec]');
            const data = {};

            data.items   = $enec_el.data('enec-items');
            data.coupons = $enec_el.data('enec-coupons');
            data.total   = parseFloat($enec_el.data('enec-total'));

            return data;
        }
    }


    /**
     * This function is called to retrieve the chosen payment method
     */
    function wpg_shop_get_payment_method() {
        var $payment = $('.payment_method:checked');
        var payment_title = $payment.data('payment-title').trim().toLowerCase();

        if (payment_title == "happinez cadeaukaart") {
            payment_title = "cadeaukaart";
        }

        return payment_title;
    }

    function wpg_get_ga_client_id() {
        try {
            var trackers = ga.getAll();
            var i, len;

            for (i = 0, len = trackers.length; i < len; i += 1) {
                return trackers[i].get('clientId');
            }
        } catch(e) {}

        return;
    }

    /**
     * Add ga client id to input field
     */
    $(document.body).on("updated_checkout", function (e) {
        let client_id_input = $('input[name="enec_ga_client_id"]');

        if (client_id_input.length) {
            client_id_input.val(wpg_get_ga_client_id());
        }
    });
});